module.exports = __webpack_public_path__ + "static/media/project-image-effect-flipped.e64817a7.png";